module.exports = __webpack_public_path__ + "static/media/walmart_image_en.b7a90df1.png";